import { EquipmentStateSelectV2 } from '@frontend/equipment/select';
import { EquipmentStateName } from '@frontend/equipment/types';
import { updateField } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useEquipmentStateConstraintDataInput from './equipment-state-constraint-data-input.controller';

const ID = 'equipment-state-constraint-data-input';
export interface EquipmentStateConstraintDataInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const EquipmentStateConstraintDataInput = (props: EquipmentStateConstraintDataInputProps) => {
    const viewProps = useEquipmentStateConstraintDataInput(props);

    return (
        <div
            id={ID}
            className='flex w-full flex-row'>
            <EquipmentStateSelectV2
                required
                value={viewProps.formValues?.state ?? null}
                onSelect={(v) => {
                    props.dispatch(updateField({ formId: props.formId, key: 'data', value: v ? { state: v.value as EquipmentStateName } : undefined }));
                }}
            />
        </div>
    );
};

export default EquipmentStateConstraintDataInput;
